module.exports = __webpack_public_path__ + "img/TravelsDialog.38ca1fff.png";